import { Field } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';

let BsCompactionMoistureContentDeterminationEquipmentSection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
}) => {
  return (
    <ListFieldSection>
      <WorksheetBalanceFieldSet label="Balance" name="Equipment.MoistureDeterminationBalance" />

      <Field
        input={<WorksheetEquipmentDropdown />}
        label="Oven"
        equipmentType="oven"
        name="Equipment.MoistureDeterminationOven"
      />

      <WorksheetBalanceFieldSet label="Dry Mass Balance" name="Equipment.MoistureDeterminationDryMassBalance" />
    </ListFieldSection>
  );
};

BsCompactionMoistureContentDeterminationEquipmentSection = withInjectedProps(
  BsCompactionMoistureContentDeterminationEquipmentSection
);

export { BsCompactionMoistureContentDeterminationEquipmentSection };
export default BsCompactionMoistureContentDeterminationEquipmentSection;
